export default "__VITE_ASSET__CFuuDkwr__"